
$(document).ready(function(){
	$("#toggle-sidebar").on('click', function(e){
		$('body').toggleClass('sidebar-open');
	});	

	$(document).mouseup(function(e) 
	{
	    var sidebar = $("#sidebar");
	    if (!sidebar.is(e.target) && sidebar.has(e.target).length === 0) 
	    {
	        $('body').removeClass('sidebar-open');
	    }
	});
});